import { Component, inject, output } from '@angular/core';

import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { AppleApplication } from '@rocksoft/mdm-sdk-v2';

import { AsyncPipe } from '@angular/common';
import { AppleApplicationListComponent, isNotUndefined } from '@rocksoft/shared';
import { AppleApplicationsService } from '../../services/apple-application.service';

@Component({
  selector: 'ml-mdm-apple-application-list',
  templateUrl: './application-list.container.html',
  imports: [AppleApplicationListComponent, AsyncPipe],
})
export class AppleApplicationListContainerComponent {
  private readonly applicationsService = inject(AppleApplicationsService);

  public readonly selectedApplicationChange = output<AppleApplication>();

  public readonly groupedApplications: Observable<AppleApplication[][]>;

  constructor() {
    this.groupedApplications = this.applicationsService.applications.pipe(
      map((apps) => this.groupBy(apps, (app) => app.bundleIdentifier)),
      filter(isNotUndefined)
    );
  }

  public selectedApplicationChanged(application: AppleApplication) {
    this.selectedApplicationChange.emit(application);
  }

  private groupBy(data: AppleApplication[], keyFn: (app: AppleApplication) => string): AppleApplication[][] {
    const groups = data.reduce((agg, item) => {
      const group = keyFn(item);
      agg[group] = [...(agg[group] || []), item];
      return agg;
    }, {});

    return Object.keys(groups).map((key) => groups[key]);
  }
}
